import React from 'react';
import { useTranslation } from '@lt/localization';
import LinkPopup from '../../../../../components/Popup/LinkPopup';

type AgreementProps = {
  isWhitelabel?: boolean;
  isMobile?: boolean;
  isIncludedAgreementProvisionAdditionalServices?: boolean;
};

const Agreement = ({
  isWhitelabel = false,
  isMobile = false,
  isIncludedAgreementProvisionAdditionalServices = false,
}: AgreementProps) => {
  const { t } = useTranslation();
  const agreementLink = `/articles/${
    isWhitelabel ? 'partner_license_agreement' : 'license_agreement'
  }`;
  const width = isMobile ? '90vw' : '800px';

  return (
    <>
      {t('checkout.agreement.title')}
      <LinkPopup
        href={
          isIncludedAgreementProvisionAdditionalServices
            ? '/articles/agreement?agreement_code=agreement_tour'
            : '/articles/agreement'
        }
        width={width}
      >
        {t('checkout.agreement.document')}
      </LinkPopup>
      {isIncludedAgreementProvisionAdditionalServices && (
        <LinkPopup
          href="/articles/agreement?agreement_code=agreement_extras"
          width={width}
        >
          {t('checkout.agreement.agreementProvisionAdditionalServices')}
        </LinkPopup>
      )}
      {!isIncludedAgreementProvisionAdditionalServices &&
        ` ${t('checkout.flight.and')} `}
      {!isIncludedAgreementProvisionAdditionalServices && (
        <LinkPopup href={agreementLink} width={width}>
          {t('checkout.agreement.client')}
        </LinkPopup>
      )}
      {t('checkout.agreement.familiar')}
      <LinkPopup href="/articles/order_information" width={width}>
        {t('checkout.agreement.order')}
      </LinkPopup>
      {t('checkout.agreement.understand')}
      <LinkPopup href="/articles/order_information" width={width}>
        {t('checkout.agreement.charter')}
      </LinkPopup>
      {t('checkout.agreement.textPackage')}
    </>
  );
};

export default Agreement;
